$shm_hitalama_file_attach_pb $shm_hitalama_file_attach
	upload_message? \
	uploading? false
	deleting? false
	map_id \
	widget_id \
	field_name \
	form_reset null
	sub /
		<= File
		<= Name
		^ cancel_visible /
			<= Cancel $mol_button_minor
				title \Отменить загрузку
				click? <=> upload_cancel? null
		^ delete_visible /
			<= Delete_row
		<= Status $mol_status
			message <= upload_message \
			style *
				^
				color <= status_color \var(--mol_theme_focus)
